<template>
  <div class="container signing">
    <navBar/>
    <div class="mt-5 flex w-full">
      <div class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-3/4 mx-auto text-center">
        <!--<img src="@/assets/images/document/sign-success.svg" alt="Success" width="465" class="mx-auto mb-4 max-w-full">-->
        <div class="demo-alignment">
          <div class="fill-row-loading">
            <!--<div :class="{'activeLoading':activeLoading}" @click="openLoading(type)" v-for="type in types" :id="[`loading-${type}`]" class="vs-con-loading__container loading-example"></div>-->
            <div id="loading-default" class="vs-con-loading__container loading-example"></div>
          </div>
        </div>

        <transition name="fade">
          <div :key="index" >
            <h2 class="sm:mx-0 mt-5 mb-10 text-4xl d-theme-heading-color">
              <feather-icon :icon="text.icon" svgClasses="p-rela top-2 h-8 w-8  text-primary" />
              {{ text.text }}
            </h2>
          </div>
        </transition>

      </div>
    </div>

  </div>
</template>

<script>
import navBar from "@/layouts/components/navbar/NavBarHorizontalLayout.vue";

export default {
  components: {
    navBar,
  },
  computed: {
    text: function() {
      return this.texts[this.index];
    }
  },
  data:()=>({
    types:[
      'default',
    ],
    index: 0,
    texts:[
      {icon: 'ShieldIcon', text: 'Estableciendo conexión segura'},
      {icon: 'KeyIcon', text: 'Validando e.firma'},
      {icon: 'BookIcon', text: 'Verificando vigencia'},
      {icon: 'DownloadCloudIcon', text: 'Obteniendo Documento Original'},
      {icon: 'Edit3Icon', text: 'Estampando Firma'},
      {icon: 'CalendarIcon', text: 'Obteniendo TimeStamp'},
      {icon: 'DatabaseIcon', text: 'Almacenando de forma segura'},
      {icon: 'SendIcon', text: 'Enviando notificaciones'},
      {icon: 'CheckCircleIcon', text: 'Finalizando proceso...'},
    ],
  }),
  mounted(){
    this.types.forEach((type)=>{
      this.$vs.loading({
        container: `#loading-${type}`,
      })
    }),

    setInterval((index) => {
      this.index++;

    }, 2000);
  }

}


</script>

<style scoped lang="scss">
.vs-con-loading__container .con-vs-loading{
  background: #fcfcfc!important;
}

.fill-row-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  background: #fcfcfc!important;
  .loading-example {
    width: 120px;
    float: left;
    height: 120px;
    background: #fcfcfc!important;
    border-radius: 10px;
    margin: 8px;
    transition: all 0.3s ease;
    h4 {
      z-index: 40000;
      position: relative;
      text-align: center;
      padding: 10px;
    }
    &.activeLoading {
      opacity: 0 !important;
      transform: scale(0.5);
    }
  }
}
.p-rela{
  position: relative!important;
}
.top-2{
  top:2px!important;
}
.fade-leave-active {
  transition: opacity .1s ease-in;
}
.fade-enter-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0.0;
}
.fade-leave, .fade-enter-to {
  opacity: 1.0;
}

</style>
